import React from 'react';
import { CheckIcon } from 'lucide-react';
import { includedItems } from '../data/content';
export function WhatYouGet() {
  return <section className="bg-cream py-20 sm:py-24" aria-labelledby="what-you-get-title" data-id="element-203" data-mp="1026uqi186v4d">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-204" data-mp="l4mt9l3jfi2y">
        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-205" data-mp="q265ygkl7mss">Sin sorpresas</p>
        <h2 id="what-you-get-title" className="mt-4 text-center font-display text-[2.1rem] leading-tight text-petrol sm:text-5xl" data-id="element-206" data-mp="1drh19ij64ozj">
          Exactamente lo que recibes hoy
        </h2>
        <ul className="mt-10 grid overflow-hidden rounded-2xl bg-paper shadow-soft ring-1 ring-cream-line md:grid-cols-2" data-id="element-207" data-mp="142gydo1jp9g2">
          {includedItems.map(item => <li key={item} className="flex items-center gap-3.5 border-b border-cream-line px-5 py-3.5 text-[17px] text-petrol sm:px-7" data-id="element-208" data-mp="18zh2hteu424j">
              <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sage-deep text-paper" data-id="element-209" data-mp="21hbe403hmdjs">
                <CheckIcon className="h-3.5 w-3.5" strokeWidth={2.5} aria-hidden="true" data-id="element-210" data-mp="2vgvkr0xhp4dz" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}